import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';

export type Props =
	| {
			text?: string | null;
			noValueText: string;
	  }
	| {
			text: string;
			noValueText?: never;
	  };

export const TextGroupHeaderContent = ({ text, noValueText }: Props) => {
	return <Text>{text ?? noValueText}</Text>;
};
